import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getFilters } from 'src/redux/bikes/selectors';
import Label from 'components/_utility/Label';
import CloseIcon from 'src/assets/icons/close.svg';
import { filtersSelector } from 'src/redux/app/selectors';
import { resetFilter } from 'src/redux/bikes/actions';
import { Wrap, Option, Close } from './ActiveFilters.styled';

const RangeLabel = ({ from, to, values }) => {
  const fromValue = values.find(value => parseInt(value.value, 10) === from);
  const toValue = values.find(value => parseInt(value.value, 10) === to);
  const fromText = fromValue.text;
  const toText = toValue.text;

  return (
    <>
      {fromText} <Label name="toLabel" factory={label => label.toLowerCase()} /> {toText}
    </>
  );
};

const ChoiceLabel = ({ choice: choiceId, values }) => {
  const choice = values.find(value => value.value === choiceId);

  return <>{choice.text}</>;
};

const ActiveFilters = ({ fluid }) => {
  const dispatch = useDispatch();
  const filters = useSelector(filtersSelector);
  const filtersState = useSelector(getFilters);

  const activeFilters = filters
    .map((filter, index) => {
      const filterState = filtersState[index];

      if (
        !filterState ||
        (filter.type === 'options' && !filterState.choice) ||
        (filter.type === 'slider' && filterState.from === filterState.min && filterState.to === filterState.max)
      ) {
        return null;
      }

      return { index, ...filter, ...filterState };
    })
    .filter(filter => filter);

  return (
    <Wrap fluid={fluid}>
      {activeFilters.map(activeFilter => (
        <Option key={activeFilter.index} onClick={() => dispatch(resetFilter(activeFilter.index))}>
          <Close>
            <CloseIcon />
          </Close>
          {activeFilter.type === 'slider' ? <RangeLabel {...activeFilter} /> : <ChoiceLabel {...activeFilter} />}
        </Option>
      ))}
    </Wrap>
  );
};

export default ActiveFilters;
